"use strict";

exports.__esModule = true;
exports.HEADER_TYPE = exports.FILL_TYPE = exports.CUSTOM_SELECTION_TYPE = exports.CELL_TYPE = exports.AREA_TYPE = exports.ACTIVE_HEADER_TYPE = void 0;
var ACTIVE_HEADER_TYPE = 'active-header';
exports.ACTIVE_HEADER_TYPE = ACTIVE_HEADER_TYPE;
var AREA_TYPE = 'area';
exports.AREA_TYPE = AREA_TYPE;
var CELL_TYPE = 'cell';
exports.CELL_TYPE = CELL_TYPE;
var FILL_TYPE = 'fill';
exports.FILL_TYPE = FILL_TYPE;
var HEADER_TYPE = 'header';
exports.HEADER_TYPE = HEADER_TYPE;
var CUSTOM_SELECTION_TYPE = 'custom-selection';
exports.CUSTOM_SELECTION_TYPE = CUSTOM_SELECTION_TYPE;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/selection/highlight/constants.js
// module id = 117
// module chunks = 0